// player action events
import { ACTIONS as PLAYER_ACTION } from '../constants/player';

export const PLAYER = {
	REQUEST: PLAYER_ACTION,
	ON:      {
		READY:                 'player:ready',
		PLAY:                  'player:on-play',
		PAUSE:                 'player:on-pause',
		MEDIA_CHANGE:          'player:on-media-change',
		PROGRESS:              'player:progress',
		DURATION:              'player:duration',
		SNAP:                  'player:snap',
		QUALITY:               'player:on-quality-update',
		AD_MODE_ENTER:         'player:on-ad-mode-enter',
		AD_MODE_EXIT:          'player:on-ad-mode-exit',
		AD_TIME:               'player:on-ad-time',
		MONETIZATION_AD_START: 'player:on-monetization-ad-start',
		LOAD:                  'player:on-load',
		ACCESS_DENIED:         'player:on-access-denied',
		REQUEST_FAILED:        'player:on-request-failed',
	},
};

export const EVENT_UPDATE = 'event:update';

export const TAG_PLAY = 'tag:play';
export const TAG_EDIT = 'tag:edit';
export const TAG_DELETE = 'tag:delete';
export const TAG_BEFORE_CREATE = 'tag:before-create';
export const TAG_CREATE = 'tag:create';

export const FULLSCREEN_TOGGLE = 'fullscreen:toggle';
export const COUCH_TOGGLE = 'couch:toggle';

export const SHARE_TAG = 'share:tag';
export const SHARE_EVENT = 'share:event';
export const SHARE_CLIP = 'share:clip';
export const DISPLAY_QUALITY_MODAL = 'quality:display';

export const CLIPLIST_ITEM_HOVER = 'cliplist:item-hover';
export const CLIPLIST_ITEM_UNHOVER = 'cliplist:item-unhover';
export const TIMELINE_HIGHLIGHT_TAGS = 'timeline:highlight-tags';
export const TIMELINE_HIGHLIGHT_CLEAR = 'timeline:highlight-clear';
export const TIMELINE_EDIT_LATEST_TAG = 'timeline:edit-latest-tag';

export const COUCH_SEEK_BACKWARDS = 'couch:seek:backwards';
export const COUCH_SEEK_FORWARDS = 'couch:seek:forwards';

export const ERROR = 'error';
export const SUCCESS = 'success';

export const TIMELINE_EDIT_UPDATE = 'timeline:edit:update';
export const TIMELINE_TAG_CREATED = 'timeline:tag-created';

export const TIMELINE_TAG_PREVIEW_OPEN = 'timeline:tag-preview-open';
export const TIMELINE_TAG_PREVIEW_CLOSE = 'timeline:tag-preview-close';

export const COUCH_EXIT = 'couch:exit';

export const CLIP_CREATE_VIDEO = 'clip:create-video';
export const CLIP_DOWNLOAD_VIDEO = 'clip:download-video';

export const TAG_BUTTONS_PARTICIPANT_SELECT = 'tag-buttons:participant-select';

export const RESET_OVERLAY_TIMEOUT = 'overlay:reset-timeout';

// time picker modal mobile
export const TIME_PICKER_MODAL_OPEN = 'time-picker-modal:open';
export const TIME_PICKER_MODAL_CLOSE = 'time-picker-modal:close';

export const PARALLEL_VIEW_DETECTED = 'player:parallel_view_detected';
export const PAYMENT_REQUIRED = 'player:payment_required';

export const PLAYOUT_API_ERRORS = {
	EVENT_GEOBLOCKED: 'geoblocked',
	PAYMENT_REQUIRED: 'payment',
	PARALLEL_STREAM:  'parallelStream',
	PREVIEW_LIMIT:    'previewLimit',
	AUTH:             'auth',
};

export const STREAM_START_CHANGED = 'stream:start-changed';

export const NETWORK_UNFORCED_CLIENT_ERROR = 'network:unforced-client-error'; // Network connection lost / no internet
export const NETWORK_CLIENT_ERROR = 'network:client-error'; // Not found, forbidden, etc.
export const NETWORK_SERVER_ERROR = 'network:server-error'; // 5xx errors
